export default function (store) {
    let $menu = null;
    let $menu_button = null;
    let $menu_button_icon = null;

    let is_open = false;
    let is_logged_in = false;

    let unsubscribe_auth = null;

    const links = [
        // { href: "/dashboard", icon: "dashboard", text: "Dashboard", authenticated: true },
        { href: "/", icon: "home", text: "Home" },
        { href: "/ketv", icon: "tv-retro", text: "KETV" },
        { href: "/vod", icon: "rectangle-video-on-demand", text: "VOD" },
        // { href: "/shop", icon: "store", text: "Shop" },
        { href: "/history", icon: "crown", text: "History" },
        { href: "/contact", icon: "message", text: "Contact" },
    ];

    const openMenu = () => {
        is_open = true;
        $menu.classList.add("is-open");
        $menu_button?.setAttribute("aria-expanded", "true");
        $menu_button_icon?.classList.remove("fa-bars");
        $menu_button_icon?.classList.add("fa-times");
    }

    const closeMenu = () => {
        is_open = false;
        $menu.classList.remove("is-open");
        $menu_button?.setAttribute("aria-expanded", "false");
        $menu_button_icon?.classList.remove("fa-times");
        $menu_button_icon?.classList.add("fa-bars");
    }

    const toggleMenu = () => {
        is_open ? closeMenu() : openMenu();
    }

    const renderLinks = () => {
        return links.filter(link => {
            if (link.authenticated) return is_logged_in;

            return true;
        }).map(link => `
        <li>
            <a href="${link.href}">
                <i class="fas fa-${link.icon}"></i>
                <span>${link.text}</span>
            </a>
        </li>
    `).join('');
    }

    const renderAccountLinks = () => {
        if (!is_logged_in) {
            return `
                <li>
                    <a href="/login" class="mobile">
                        <i class="fas fa-arrow-right-to-bracket"></i>
                        <span>Log In</span>
                    </a>
                </li>
                <li>
                    <a href="/register" class="mobile">
                        <i class="fas fa-circle-user-circle-plus"></i>
                        <span>Register</span>
                    </a>
                </li>
            `
        } else {
            return `
                <li>
                    <a href="/account/details" class="mobile">
                        <i class="fas fa-circle-user"></i>
                        <span>My Account</span>
                    </a>
                </li>
                <li>
                    <a href="/account/subscriptions" class="mobile">
                        <i class="fas fa-star"></i>
                        <span>Subscriptions</span>
                    </a>
                </li>
                <li>
                    <a href="/logout" class="mobile">
                        <i class="fas fa-person-to-door"></i>
                        <span>Log Out</span>
                    </a>
                </li>
            `
        }
    }

    return {
        render() {
            return `
                <ul>
                    ${renderLinks()}
                    <li class="separator" aria-hidden="true"></li>
                    ${renderAccountLinks()}
                </ul>
            `;
        },

        _boundToggle: null,
        _followLink: null,
        _onKeyDown: null,

        async onMount() {
            $menu = document.getElementById("MainMenu");
            $menu_button = document.getElementById("MainMenuButton");
            $menu_button_icon = $menu_button.querySelector("i");

            is_logged_in = store.get("auth").logged_in;

            $menu.innerHTML = this.render();

            this._boundToggle = () => toggleMenu();
            $menu_button.addEventListener("click", this._boundToggle);

            // Close on menu link click (useful for SPA navigation)
            this._followLink = (e) => {
                if (e.target.closest("a")) {
                    closeMenu();
                }
            }
            $menu.addEventListener("click", this._followLink);

            // Escape key support
            this._onKeyDown = (e) => {
                if (e.key === "Escape" && is_open) closeMenu();
            };
            document.addEventListener("keydown", this._onKeyDown);

            // Subscribe to store changes
            unsubscribe_auth = store.subscribe("auth", auth => {
                if (is_logged_in !== auth.logged_in) {
                    $menu.innerHTML = this.render();
                }
            });
        },

        async onUnmount() {
            $menu_button?.removeEventListener("click", this._boundToggle);
            $menu?.removeEventListener("click", this._followLink);
            document.removeEventListener("keydown", this._onKeyDown);

            if (unsubscribe_auth) unsubscribe_auth();
        },

        close: closeMenu,
    };
};
